import { render, staticRenderFns } from "./m-product-options-group.vue?vue&type=template&id=64344feb&scoped=true&"
import script from "./m-product-options-group.vue?vue&type=script&lang=js&"
export * from "./m-product-options-group.vue?vue&type=script&lang=js&"
import style0 from "./m-product-options-group.vue?vue&type=style&index=0&id=64344feb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64344feb",
  null
  
)

export default component.exports